import React from 'react';
import { selectActiveOrganization, selectUser } from 'redux/auth';

import { useAppSelector } from 'redux/hooks';
import { exists } from 'lib/types';
import Payments from './PaymentsRoute';

function PaymentsWrapper() {
  const user = useAppSelector(selectUser);
  const activeOrganization = useAppSelector(selectActiveOrganization);
  if (!exists(user)) {
    return <></>;
  }
  return <Payments user={user} organization={activeOrganization} />;
}

export default PaymentsWrapper;
